import { DefaultButton, IContextualMenuProps, PrimaryButton } from "@fluentui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faFloppyDisk, faRotateLeft, faUpload } from "@fortawesome/free-solid-svg-icons";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import React, { useContext } from "react";
import { DraftStatus, shiftsContext } from "../../providers/shifts";

const DraftControl = () => {
    const { draftStatus, deleteDraft, saveDraft, loadDraft, undoShiftMove, validateAndPublishShifts: validateAndPublishShifts, reloadShifts,validateAllShifts } = useContext(shiftsContext)

    const renderDraftButton = () => {
        const menuProps: IContextualMenuProps = {
            items: [
                {
                    key: 'saveDraft',
                    text: 'Save Draft',
                    onClick: saveDraft,
                    disabled: draftStatus !== DraftStatus.empty && draftStatus !== DraftStatus.edited
                },
                {
                    key: 'loadDraft',
                    text: 'Load Draft',
                    onClick: loadDraft,
                    disabled: draftStatus === DraftStatus.empty
                },
                {
                    key: 'discardDraft',
                    text: 'Discard Draft',
                    onClick: deleteDraft,
                    disabled: draftStatus === DraftStatus.empty
                }
            ]
        }

        return <DefaultButton menuProps={menuProps}>Drafts</DefaultButton>
    }

    const renderValidateButton = () => {
        const menuProps: IContextualMenuProps = {
            items: [
                {
                    key: 'validate',
                    text: 'Validate',
                    onClick: validateAllShifts
                },
                {
                    key: 'publish',
                    text: 'Publish',
                    onClick: validateAndPublishShifts
                }
            ]
        }

        return <PrimaryButton menuProps={menuProps}>Validate</PrimaryButton>
    }
    return (
        <div style={{ display: "inline-flex", gap: '5px',alignItems:'center' }}>
            {/*<DefaultButton onClick={calculateCost}>*/}
            {/*    Estimate Cost*/}
            {/*</DefaultButton>*/}
            {renderDraftButton()}
            {renderValidateButton()}
            <DefaultButton className="rb-small-button" onClick={undoShiftMove} title="Undo">
                <FontAwesomeIcon icon={["fas", "rotate-left" as IconName]} />
            </DefaultButton>
            <DefaultButton className="rb-small-button" onClick={reloadShifts} title="Reload">
                <FontAwesomeIcon icon={["fas", "arrows-rotate" as IconName]} />
            </DefaultButton>
        </div>

    )
}

export { DraftControl }
